if (typeof $ !== "undefined" && $(".logo__slider_main .logo-list").length) {
  $(".logo__slider_main .logo-list").each(function (slider) {
    $(this).slick({
      centerMode: true,
      centerPadding: "10px",
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: "10px",
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: "10px",
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
}

/**
 * Defensive fix for mobile add-to-cart.
 *
 * Some product templates render the variant id input with `disabled` so the
 * theme's own variant picker can take over via JS. On mobile Safari with
 * custom elements + module imports + variant dropdown popovers, the input
 * sometimes stays disabled, which makes /cart/add.js return 422 (Bad Request)
 * with no visible error and the customer assumes "nothing happened".
 *
 * This script:
 *   - Removes `disabled` from every <input name="id"> inside a product form.
 *   - Re-applies that fix when variants change.
 *   - Ensures the form data sent on submit always includes a numeric variant id.
 */
(function () {
  function enableVariantIdInputs(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll(
      'form[is="product-form"], form[id^="product-form-"]'
    );
    forms.forEach(function (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.disabled) {
        idInput.disabled = false;
      }
    });
  }

  // Inside {% form 'product' %}, passing form: blank to the button snippet can
  // resolve to Shopify's form object and render form="" on the submit button.
  // That disconnects the button from the product form on iOS Safari (tap does nothing).
  function fixProductSubmitButtons(root) {
    var scope = root || document;
    scope
      .querySelectorAll(
        'form[is="product-form"] button[type="submit"], form[id^="product-form-"] button[type="submit"]'
      )
      .forEach(function (button) {
        var targetForm = button.getAttribute("form");
        if (targetForm === "" || targetForm === null) {
          button.removeAttribute("form");
        }
      });
  }

  function bind() {
    enableVariantIdInputs();
    fixProductSubmitButtons();

    // After any variant change, make sure the id input is still enabled
    // and has a value (the theme writes the new variant id to it).
    document.addEventListener("variant:change", function () {
      enableVariantIdInputs();
      fixProductSubmitButtons();
    });

    // Last-line-of-defense: if a product form is submitted but the id field
    // is missing or empty, append the value from the variant picker before
    // the request goes out.
    document.addEventListener(
      "submit",
      function (event) {
        var form = event.target;
        if (
          !form ||
          form.tagName !== "FORM" ||
          form.getAttribute("is") !== "product-form"
        ) {
          return;
        }

        var idInput = form.querySelector('input[name="id"]');
        if (idInput && idInput.disabled) {
          idInput.disabled = false;
        }
      },
      true
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }

  document.addEventListener("shopify:section:load", function () {
    enableVariantIdInputs();
    fixProductSubmitButtons();
  });
})();
